export const CAMPAIGNS_KEYS = {
  MOTHER_DAY: 'mother_day_raffle',
  /**
   * 菲利宾活动，只需支持en
   */
  BINI_CONCERT_RAFFLE: 'bini_concert_raffle'
};

export const CMS_PAGE_CTX = 'page_ctx';
